import type { Neighborhood } from '@repo/api';

type AccordionEntry = {
  parents: { id: string }[];
  childrenByParent: Record<string, { id: string }[]>;
};

type ExtendedNeighborhood = Pick<Neighborhood, 'id' | 'name' | 'borough'> & {
  parentId?: string | null;
};

export function formatListingAlertLocationLabel(
  selectedIds: string[] | null | undefined,
  neighborhoods: ExtendedNeighborhood[],
  accordion: Record<string, AccordionEntry> | null | undefined,
) {
  const ids = Array.isArray(selectedIds) ? selectedIds : [];
  if (ids.length === 0) return '';

  const byId = new Map(neighborhoods.map(n => [n.id, n] as const));
  const selectedSet = new Set(ids);
  const fullySelectedBoroughs = new Set<string>();

  if (accordion) {
    for (const [borough, entry] of Object.entries(accordion)) {
      const allIds = [
        ...entry.parents.map(parent => parent.id),
        ...Object.values(entry.childrenByParent)
          .flat()
          .map(child => child.id),
      ];
      if (allIds.length > 0 && allIds.every(id => selectedSet.has(id))) {
        fullySelectedBoroughs.add(borough);
      }
    }
  }

  const labels: string[] = [];
  const emittedBoroughs = new Set<string>();
  for (const id of ids) {
    const neighborhood = byId.get(id);
    if (!neighborhood) continue;

    if (fullySelectedBoroughs.has(neighborhood.borough)) {
      if (!emittedBoroughs.has(neighborhood.borough)) {
        emittedBoroughs.add(neighborhood.borough);
        labels.push(neighborhood.borough);
      }
      continue;
    }

    if (neighborhood.parentId && selectedSet.has(neighborhood.parentId)) {
      continue;
    }

    labels.push(neighborhood.name);
  }

  if (labels.length === 0) return '';
  if (labels.length === 1) return labels[0] as string;
  return `${labels[0]} + ${labels.length - 1} ${labels.length === 2 ? 'location' : 'locations'}`;
}
